/**
 * @module components\ghTable\vuetifyTable\vuetifyRow\vuetifyCell\template\cellCheckbox
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "../../base";

@Component
export default class CellCheckbox extends Base {}
